import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=2bcda66f&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=2bcda66f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcda66f",
  null
  
)

export default component.exports